<div class="modal-header noselect">
  <h2 class="modal-title">Reject Work Item</h2>
  <button type="button" class="btn-close" (click)="onCancel()">
    <span class="fa-solid fa-xmark"></span>
  </button>
</div>

<div class="modal-body">
  <p class="noselect">
    Reject <strong>{{ workItemTitle }}</strong>? The invoice will return to the shop
    for this work item to be removed or revised.
  </p>

  <label for="rejectionReason" class="form-label noselect">Reason (optional)</label>
  <textarea id="rejectionReason"
            class="form-control"
            rows="3"
            maxlength="500"
            placeholder="Let the shop know why you're rejecting this item..."
            [(ngModel)]="reason"></textarea>
</div>

<div class="modal-footer noselect">
  <button type="button" class="btn btn-secondary" (click)="onCancel()">
    Cancel
  </button>
  <button type="button" class="btn btn-danger" (click)="onReject()">
    Reject Work Item
  </button>
</div>
